import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../../environments/environment";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

/**
 * Pipe to transform a filename into a proxied image URL with specified modifiers.
 */
@Pipe({
  name: "photoProxy",
  standalone: false,
})
export class PhotoProxyPipe implements PipeTransform {
  // Base URL for CDN
  cdnUrl: string = environment.cdnUrl;

  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Transforms a filename into a proxied image URL with specified modifiers.
   * @param filename The filename of the image.
   * @param resolution The desired resolution for the image (e.g., "328:216").
   * @param dpr The device pixel ratio (default is 1).
   * @param path The path to the image directory (default is "items/pictures").
   * @param bucket The name of the bucket (default is "inventories").
   * @returns A Promise resolving to the proxied image URL with specified modifiers.
   */
  transform(
    filename: string,
    resolution: string = "328:216",
    dpr: number = 1,
    path: string = "items/pictures",
    bucket: string = "inventories"
  ): SafeUrl {
    // Construct modifiers for the image
    const modifiers = `rs:fit:${resolution}:1/g:ce/dpr:${dpr}`;
    let imageSrc;

    // If filename is provided, construct the image URL with modifiers
    if (filename) {
      path = "s3://" + bucket + ".prague/" + path + "/" + filename;
      imageSrc =
        this.cdnUrl + "/plain/" + modifiers + "/" + btoa(path) + ".webp";
    }

    return this.sanitizer.bypassSecurityTrustUrl(imageSrc);
  }
}
